import {
  getRandomFromArr,
  isNotUndefined,
  partition,
  sumArr,
} from "../utils/dictionaries";
import {
  addStatus,
  CharacterHandler,
  CharacterState,
  StatusType,
} from "./characters";
import {
  Faction,
  FactionAgent,
  FactionType,
  SocialHandler as SH,
  SocialHandler,
} from "./social";
import { isDmgStatus, StatusHandler } from "./status";
import { WorldHandler, WorldState } from "./world";

enum WarCasusBelli {
  STARVATION = "STARVATION",
}

export type War<T extends FactionType> = {
  factionGroupA: Faction<T>[];
  factionGroupB: Faction<T>[];
  score: number; //positive if factionA has advantage, negative otherwise
};

export type BattleResult = {
  agentsA: FactionAgent[];
  agentsB: FactionAgent[];
  agentsNeutral: FactionAgent[];
  score: number; //positive if factionA has advantage, negative otherwise
};

const fightRoll = (agent: FactionAgent): number => {
  //@TODO: CHILDREN/OLD IMPACT
  //@TODO: GENE IMPACT Strong/Agile/Weak
  return 1;
};

export class WarHandler {
  static doWar = (world: WorldState): WorldState => {
    const { wars, characters, factions } = world;

    //WAR RESOLUTION
    //pour chaque factionPos
    const { agentGroups, meta, unmatched } = SH.SplitByFaction(
      FactionType.POS,
      characters,
      factions
    );
    //Et pour chaque War
    const warResults: BattleResult[][] = wars.map((war): BattleResult[] => {
      const { factionGroupA, factionGroupB } = war;

      const factionGroupAFilter = SH.createIsFactionGroupMember(factionGroupA);
      const factionGroupBFilter = SH.createIsFactionGroupMember(factionGroupB);
      // const [atWarAgents, notAtWarAgents][] = agentGroups.map(ag => partition(ag, a => factionGroupAFilter(a) || factionGroupBFilter(a) ))

      const agentsGroupA = agentGroups.map((agents) =>
        agents.filter(factionGroupAFilter)
      );
      const agentsGroupB = agentGroups.map((agents) =>
        agents.filter(factionGroupBFilter)
      );

      const agentsGroupNeutral = agentGroups.map((agents) =>
        agents.filter((a) => !factionGroupAFilter(a) && !factionGroupBFilter(a))
      );

      const battlesResults = agentsGroupA.map((agentsA, i) => {
        const agentsB = agentsGroupB[i];
        const agentsNeutral = agentsGroupNeutral[i];
        const scoreA = sumArr(agentsA.map(fightRoll));
        const scoreB = sumArr(agentsB.map(fightRoll));
        const score = scoreA - scoreB;

        const getWoundedPartition = (
          allied: FactionAgent[],
          ennemies: FactionAgent[],
          score: number
        ) => {
          const woundedNum = Math.min(allied.length, score);

          const addWoundEffect = (a: FactionAgent, i: number) => {
            const char = a as CharacterState;
            return addStatus(
              StatusHandler.createDmgStatus(StatusType.WOUNDED, {
                dmg: 10,
                by: (getRandomFromArr(ennemies) as CharacterState).id,
              }),
              char
            );
          };

          return {
            wounded: allied
              .slice(0, woundedNum)
              .map((a) => ({
                ...a,
              }))
              .map(addWoundEffect),
            notWounded: allied.slice(woundedNum, allied.length),
          };
        };

        const { wounded: woundedA, notWounded: notWoundedA } =
          getWoundedPartition(agentsA, agentsB, scoreB);
        const { wounded: woundedB, notWounded: notWoundedB } =
          getWoundedPartition(agentsB, agentsA, scoreA);

        const newAgentsA: FactionAgent[] = [...woundedA, ...notWoundedA];
        const newAgentsB: FactionAgent[] = [...woundedB, ...notWoundedB];
        /*
        console.log(
          "NEW AGENTS A STATUS",
          (woundedA as CharacterState[]).map((c) => c.statusList)
        );
        console.log(
          "NEW AGENTS B STATUS",
          (woundedB as CharacterState[]).map((c) => c.statusList)
        );
        */

        return {
          agentsA: newAgentsA,
          agentsB: newAgentsB,
          agentsNeutral,
          score,
        };
      });

      return battlesResults;
    });

    const newCharactersIterations: FactionAgent[][] = warResults.map((wr) =>
      wr.reduce((chars: FactionAgent[], br: BattleResult): FactionAgent[] => {
        //console.log("neutral num", br.agentsNeutral.length);
        return [...chars, ...br.agentsA, ...br.agentsB, ...br.agentsNeutral];
      }, [])
    );

    /*
    console.log("battlesResults", warResults);
    console.log(
      "CHECK CHARACTERS NUM",
      characters.length,
      newCharactersIterations.map((newCharacters) => newCharacters.length)
    );
*/

    //chaque agents de la factionA additionne son score de battaille

    //roll pour tous les membre de la factionGroupA et factionGroupB à la POS

    //Si valeur abs de score > WIN_threshold => la guerre s'arrete

    return newCharactersIterations.reduce((newWorld, agents) => {
      const characters = agents as CharacterState[];
      return {
        ...newWorld,
        characters,
      };
    }, world);
  };
}
